import "./HomeSliderContact.scss" 

import React, { FC, useContext, useEffect, useRef, useState } from "react"
import Footer from "../Layout/Footer"
import NavContext from "../Layout/Nav/NavProvider"
import { getCurrentLanguage } from '../../i18n';
import { useSwiperSlide } from 'swiper/react';
import { useInView } from "../../hooks/useInView";
import { t } from 'i18next';
import { YouplanetSections, getSectionSlug } from "../../constants/general";

const HomeSliderContact: FC = () => {
  const { setFooterInView, isMobile } = useContext(NavContext);
  const [isMobileActive, setIsMobileActive] = useState<boolean>(false);

  const textsSlide = () => {
    return <span className="home-slider-contact__text">
            <strong> {t('homeContact.textSlider.brandedContent')} </strong> · <strong>{t('homeContact.textSlider.influencerMarketing')}</strong> · <strong>{t('homeContact.textSlider.brandStrategy')}</strong> · <strong>{t('homeContact.textSlider.audiovisualProduction')}</strong> · <strong>{t('homeContact.textSlider.trendhunting')}</strong> ·&nbsp;
          </span>
  }
  
  const footerRef = useRef<HTMLDivElement>();
  const inView = useInView(footerRef, {
    root: null,
    rootMargin: '0px',
    threshold: 0.851 
  });
  
  const swiperSlide = useSwiperSlide();

  useEffect(() => {
    setIsMobileActive(isMobile());
  }, [isMobile])

  useEffect(() => {
    setFooterInView(swiperSlide?.isActive || inView);

  }, [swiperSlide?.isActive, inView]);

  return (
    <div ref={footerRef} className={`home-slider-contact ${isMobileActive ? 'is-active' : ''}`}>
      <div className="home-slider-contact__content">
        <div className="home-slider-contact__background"></div>     

        <a href={getSectionSlug(YouplanetSections.Contact, getCurrentLanguage())} className="home-slider-contact__title">
          <span className="home-slider-contact__help"> {t('homeContact.howCanWeHelpYou')} </span>
          <span className="home-slider-contact__random-text"> {t('homeContact.randomText1')} </span>
          <span className="home-slider-contact__random-text-secondary"> {t('homeContact.randomText2')} </span>
          <span className="home-slider-contact__random-text-terciary"> {t('homeContact.randomText3')} </span>
          <h2 className="home-slider-contact__cta"> {t('homeContact.contactUs')} </h2>
        </a>

        <p className="home-slider-contact__text-container">
          {textsSlide()}
          {textsSlide()}
        </p>
      </div>
      <div className="home-slider-contact__footer">
        <Footer />
      </div>
    </div>
  )
}

export default HomeSliderContact
